import { Component, useCallback } from 'react';
import { toast } from 'sonner';

/* Gemeinsame Teile des Ernährungsbereichs auf /coach (15.10.2026): Fehlertext, Rollen, Link-Umleitung, Karten-Schutz,
   Hinweis. Eigene Datei, damit Bereich ↔ Cockpit/Kunden keinen Import-Kreis bilden. */

export const fehlertext = (e, rest = 'Das hat nicht geklappt') => (typeof e?.response?.data?.detail === 'string' ? e.response.data.detail : rest);
export const ist403 = (e) => e?.response?.status === 403;

/* Rollen auf /coach: Master und Overviewer pflegen (Sequenzen, Kochbücher, Einstellungen), PT sieht seine Kunden. */
export const darfPflegen = (ich) => !!(ich?.master || ich?.rolle === 'overviewer');

/* CRM-Links in den eingebundenen Karten → Ziel auf /coach. null = kein CRM-Ziel (Link läuft normal weiter). */
export function zielAusHref(href) {
  let u;
  try { u = new URL(href, window.location.origin); } catch { return null; }
  if (u.origin !== window.location.origin) return null;
  const p = u.pathname;
  const hash = (u.hash || '').replace('#', '');
  let m;
  if ((m = p.match(/^\/ernaehrung\/mitglied\/([^/]+)$/)) || (m = p.match(/^\/ernaehrung\/([^/]+)$/))) {
    if (m[1] === 'vorlagen') return { sperre: 'Plan-Vorlagen pflegt das Studio im CRM.' };
    return { ansicht: 'e-kunden', mitglied: m[1], reiter: hash === 'formulare' ? 'formulare' : 'plan' };
  }
  if ((m = p.match(/^\/ernaehrung\/vorlagen\/[^/]+$/))) return { sperre: 'Plan-Vorlagen pflegt das Studio im CRM.' };
  if (p === '/coaching-cockpit') { const k = u.searchParams.get('kunde'); return { ansicht: 'e-cockpit', ...(k ? { kunde: k } : {}) }; }
  if ((m = p.match(/^\/leads\/([^/]+)$/))) return { ansicht: 'e-kunden', mitglied: m[1], reiter: 'uebersicht' };
  if (p === '/ernaehrung') {
    const r = u.searchParams.get('reiter');
    if (r === 'automatik') return { ansicht: 'e-automatik' };
    if (r === 'kochbuecher') return { ansicht: 'e-kochbuecher' };
    if (r === 'einstellungen') return { ansicht: 'e-einstellungen' };
    return { ansicht: 'e-kunden' };
  }
  if (p === '/freigabe') return { sperre: 'Die Freigabe-Zentrale gibt es nur im CRM.' };
  return null;
}

/* Fängt Klicks auf <a href> der CRM-Karten ab (Capture-Phase, vor react-router) und ruft gehe() auf. */
export function LinkUmleitung({ gehe, children }) {
  const onClick = useCallback((e) => {
    const a = e.target?.closest?.('a[href]');
    if (!a || a.target === '_blank' || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey) return;
    const ziel = zielAusHref(a.getAttribute('href'));
    if (!ziel) return;
    e.preventDefault(); e.stopPropagation();
    if (ziel.sperre) { toast.message(ziel.sperre); return; }
    gehe(ziel);
  }, [gehe]);
  // Nur Abfangen von Klicks auf Links darin — kein eigenes Bedienelement, darum keine Rolle und keine Tastenbindung
  return <div onClickCapture={onClick}>{children}</div>;
}

/* Jede CRM-Karte für sich: ein Fehler beim Zeichnen nimmt nicht die ganze Seite mit. */
export class KarteSchutz extends Component {
  constructor(p) { super(p); this.state = { kaputt: false }; }
  static getDerivedStateFromError() { return { kaputt: true }; }
  componentDidCatch() { /* nur anzeigen */ }
  componentDidUpdate(vorher) { if (vorher.schluessel !== this.props.schluessel && this.state.kaputt) this.setState({ kaputt: false }); }
  render() {
    if (this.state.kaputt) {
      return <div className="rounded-[14px] border border-border/70 bg-card p-4 text-sm text-muted-foreground" role="alert">{this.props.titel ? `${this.props.titel}: ` : ''}Diese Karte konnte gerade nicht angezeigt werden.</div>;
    }
    return this.props.children;
  }
}

/* Hinweis statt Knopf: Was die Leitung im CRM entscheidet, steht hier nur als Satz. */
export function Hinweis({ children, art = 'info' }) {
  return <p className={`rounded-[10px] border px-3 py-2 text-sm ${art === 'warn' ? 'border-amber-300 bg-amber-500/10' : 'border-border/70 bg-muted/50 text-muted-foreground'}`} role="status">{children}</p>;
}
